var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.125 26.469L25.75 20l-8.625-6.469V26.47zM20 5.625c-7.935 0-14.375 6.44-14.375 14.375S12.065 34.375 20 34.375 34.375 27.935 34.375 20 27.935 5.625 20 5.625zM20 31.5c-6.34 0-11.5-5.16-11.5-11.5S13.66 8.5 20 8.5 31.5 13.66 31.5 20 26.34 31.5 20 31.5z",
    fill: "#20C1E7"
  })));
}
export default SvgPlayCircleOutline;